import { MarketingChannel } from "@redotech/redo-billing-common/marketing-channel";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { analyticsAttributionInput } from "./analytics-attribution-input";

const dailyMessageMetricsRowSchema = z.object({
  DATE: z.date(),
  EMAIL_SENT: z.number(),
  SMS_SENT: z.number(),
  TOTAL_SENT: z.number(),
});

const messagePerformanceTotalsSchema = z.object({
  totalMessagesSent: z.number(),
  totalEmailsSent: z.number(),
  totalSmsSent: z.number(),
  totalOpens: z.number(),
  totalClicks: z.number(),
  totalBounces: z.number(),
  totalSpam: z.number(),
  totalUnsubscribes: z.number(),
  totalOrders: z.number(),
  openRate: z.number(),
  clickRate: z.number(),
  bounceRate: z.number(),
  spamRate: z.number(),
  unsubscribeRate: z.number(),
  conversionRate: z.number(),
  previousTotalMessagesSent: z.number(),
  previousOpenRate: z.number(),
  previousClickRate: z.number(),
  previousConversionRate: z.number(),
});

export const getMessagePerformanceMetrics = {
  name: "getMessagePerformanceMetrics" as const,
  input: z.object({
    startDate: zExt.instant(),
    endDate: zExt.instant(),
    ...analyticsAttributionInput,
    channels: z.array(createEnum(MarketingChannel)).optional(),
  }),
  output: z.object({
    dailyMetrics: z.array(dailyMessageMetricsRowSchema),
    totals: messagePerformanceTotalsSchema,
  }),
};
